import { c as _c } from "react/compiler-runtime";
import { CLIENT_ID } from "@api/client-id";
import { ProjectApi } from "@api/project-api/project-api";
import { useCachedTokenProvider } from "@api/use-cached-token-provider";
import { runtimeConfig } from "@src/runtime-config";
import { useMemo } from "react";

/** Custom hook that initializes the project API client and returns an instance of it */
export function useProjectApiClient(t0) {
  const $ = _c(5);
  const {
    projectId
  } = t0;
  let t1;
  if ($[0] !== projectId) {
    t1 = {
      projectId
    };
    $[0] = projectId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tokenProvider = useCachedTokenProvider(t1);
  let t2;
  if ($[2] !== projectId || $[3] !== tokenProvider) {
    t2 = new ProjectApi({
      projectApi: new URL(runtimeConfig.urls.projectApiUrl),
      projectId,
      tokenProvider,
      clientId: CLIENT_ID
    });
    $[2] = projectId;
    $[3] = tokenProvider;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}